import * as React from 'react';

import { Navbar, NavbarGroup } from '@blueprintjs/core';
import SubNavMenuItem from '../layout/SubNavMenuItem';
import UserDetails from '../../models/UserDetails';

import './ProjectNavBar.scss';
import Authorization from 'src/util/Authorization';
import { UserRoles } from 'src/models/UserRole';
import Project from 'src/models/Project';

interface IProjectNavBarProps {
    location: string;
    matchUrl: string;
    user: UserDetails;
    currentProject: Project;
    navigate: (path: string) => void;
    onClick: () => void;
    testMode: boolean;
    collapseHeader: () => void;
}

class ProjectNavBar extends React.Component<IProjectNavBarProps> {
    private showNav(nav: JSX.Element, roles: UserRoles[], user: UserDetails, tabName: string = null) {
        let hasRole = false;
        roles.forEach((role) => {
            hasRole = hasRole || Authorization.IsInRole(role, user);
        });

        return hasRole || Authorization.IsStaffed(tabName, this.props.currentProject?.id, user) ? nav : undefined;
    }

    public render() {
        const subNavProps = {
            location: this.props.location,
            navigate: this.props.navigate,
            onClick: this.props.onClick,
            section: 'project',
        };

        const { matchUrl } = this.props;
        const tractsPaths = [
            `${matchUrl}/tracts`,
            `${matchUrl}/sections/*/tracts`,
            `${matchUrl}/sections/*/tracts/*`,
            `${matchUrl}/sections/*/tracts/*/horizons/*`,
        ];

        const leasingPaths = [`${matchUrl}/acquisitions`, `${matchUrl}/acquisitions/lease-generation/ownerId/*/leaseFormId/new-lease`];

        // TODO: ShowNav only allows for one role at a time. Fix with array of roles for easier implementation.
        return (
            <Navbar className="project-nav-bar">
                <NavbarGroup>
                    {this.props.location.includes('mapping') && 
                        <div className={ 'sub-nav-menu-item' } style={{ marginLeft: 'auto' }} onClick={() => this.props.collapseHeader()}>
                            <span>Collapse <i style={{ fontSize: '1.2rem' }} className="far fa-angle-double-up mr-1" /></span>
                        </div>
                    }
                    <SubNavMenuItem name="Dashboard" path={`${matchUrl}`} {...subNavProps} />
                    <SubNavMenuItem name="Runsheets" path={`${matchUrl}/runsheets`} {...subNavProps} />
                    <SubNavMenuItem name="Tracts" path={tractsPaths} {...subNavProps} />
                    {!this.props.testMode && (
                        <>
                            {this.showNav(
                                <SubNavMenuItem name="Owners" path={`${matchUrl}/owners`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Owners'
                            )}
                            {this.showNav(
                                <SubNavMenuItem name="Agreements" path={leasingPaths} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Contracts')}
                            {/*{this.showNav(
                                <SubNavMenuItem name="3rd-Party Leases" path={`${matchUrl}/third-party-leases`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Contracts')}*/}
                            {this.showNav(
                                <SubNavMenuItem name="Mapping" path={`${matchUrl}/mapping`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Mapping'
                            )}
                            {/*<SubNavMenuItem name="Documents" path={`${matchUrl}/documents`} {...subNavProps} />*/}
                            {this.showNav(
                                <SubNavMenuItem name="Reports" path={`${matchUrl}/reports`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Reports'
                            )}
                            {this.showNav(
                                <SubNavMenuItem name="Staffing" path={`${matchUrl}/staffing`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                                'Staffing'
                            )}
                            {this.showNav(
                                <SubNavMenuItem name="Settings" path={`${matchUrl}/settings`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator, UserRoles.ContractorSuper],
                                this.props.user,
                                'Settings'
                            )}
                            {/*{ this.showNav(
                                <SubNavMenuItem name="Tags" path={`${matchUrl}/tags`} {...subNavProps} />,
                                [UserRoles.Admin],
                                this.props.user,
                                'Tags'
                            )}*/}
                            {this.showNav(
                                <SubNavMenuItem name="Horizon Sequencing" path={`${matchUrl}/reports/6`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                            )}
                            {this.showNav(
                                <SubNavMenuItem name="Processing & Maintenance" path={`${matchUrl}/processing`} {...subNavProps} />,
                                [UserRoles.Admin, UserRoles.ProspectManager, UserRoles.ProjectCoordinator],
                                this.props.user,
                            )}
                        </>
                    )}
                </NavbarGroup>
            </Navbar>
        );
    }
}

export default ProjectNavBar;



// WEBPACK FOOTER //
// ./src/components/project/ProjectNavBar.tsx